import { api } from './client'
import type { ApiEnvelope } from '@/types/api'

export interface UploadResponseData {
  id: string
  originFileName: string
  contentType: string
  filePath: string
  fileUrl: string
  expiresIn: number
}

export async function uploadMultipartFile(
  file: File,
  folderName: string = 'media-file',
): Promise<string> {
  const responseData = await uploadMultipartFileWithInfo(file, folderName)

  return responseData.id
}

export async function uploadMultipartFileWithInfo(
  file: File,
  folderName: string = 'media-file',
): Promise<UploadResponseData> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await api.post<ApiEnvelope<UploadResponseData>>(
    '/v1/file/upload-multipart',
    formData,
    {
      params: { folderName },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )

  return response.data.responseData
}
